import { setup } from 'bem-cn';

const bem = setup({
  el: '__',
  mod: '--',
  modValue: '-',
});

export { bem };
